import type { FormMetadataParams } from "@searchui-searchforms/shared/schemas";
import { createSafeContext } from "@/shared/utils/createSafeContext";

export const [MetadataParamsProvider, useMetadataParamsContext] =
    createSafeContext<FormMetadataParams>("MetadataParamsContext");
